var React = require('react');
var Login = require('Login');

var Main = React.createClass({
	render: function() {
		return (
			<div>
				{this.props.children}
			</div>
			
			);
			
	}
});

module.exports = Main;


// WEBPACK FOOTER //
// ./react/app/components/Main.jsx